import React from 'react';

type EmojiProps = {
    children: string;
};
export function Emoji({children}: EmojiProps) {
    return <span className="font-emoji">{children}</span>;
}
